import React from "react";
import { useState, useRef } from "react";
import { useEffect } from "react";

const BannerLiveTimer = ({ countDownDate }) => {
  const [time, setTime] = useState({});
  const timerRef = useRef();
  const [isTimerOn, setIsTimerOn] = useState(true);

  //const countDownDate =  duration?.duration?.month>=0 ?  : new Date(new Date().toDateString() + ' 24:00:00').getTime();
  //const countDownDate = new Date(2022,7,29,11,4,0).getTime();

  useEffect(() => {
    timerRef.current = setInterval(function () {
      const now = Date.now();
      const timeleft = countDownDate - now;
      const hours = Math.floor(timeleft / (1000 * 60 * 60));
      const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
      if (hours < 0 && minutes < 0 && seconds < 0) {
        setIsTimerOn(false);
      } else {
        setIsTimerOn(true);
      }

      // Result is output to the specific element
      // document.getElementById('days').innerHTML = days + 'd ';
      setTime({ h: hours, m: minutes, s: seconds });

      // Display the message when countdown is over
      if (timeleft < 0) {
        clearInterval(timerRef.current);
        // setTime to 0
      }
    }, 1000);

    return () => {
      clearInterval(timerRef.current);
    };
  }, [countDownDate]);

  return (
    isTimerOn && (
      <div className="mx-2 flex w-fit items-center justify-center rounded-md border-2 border-red-800 bg-white text-xs font-bold text-red-800 md:mx-2 md:px-2 md:text-lg">
        <div className="flex w-full gap-1 px-2">
          <div className="text-center">{time?.h}H</div>
          <div className="row-span-1 text-center md:row-span-2 ">:</div>
          <div className="text-center">{time?.m}M</div>
          <div className="row-span-1 text-center md:row-span-2">:</div>
          <div className="text-center">{time?.s}S</div>
          <div className="text-center">Left</div>
        </div>
      </div>
    )
  );
};

export default BannerLiveTimer;
